module.exports = __webpack_public_path__ + "img/Primordial-Process-3.fec65e27.png";